export default {
  data() {
    return {
      props: {
        'showMobile' : true,
        'showDesktop' : true,
        'height': '800px',
        'background-color': '#FFFFFF',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'backgroundImage': 'none',/*url("photographer.jpg"); The image used */
        'backgroundPosition': 'center', /* Center the image todo this resource, not possible change at the moment */
        'backgroundOrigin': 'border-box', /* padding-box|border-box|content-box Do not repeat the image */
        'backgroundRepeat': 'no-repeat', /*repeat | repeat-x | repeat-y | no-repeat | space | round   Do not repeat the image */
        'backgroundSize': 'cover', /* 'auto | 50% | 100% 100% | cover | contain  'Resize the background image to cover the entire container */
        'borderRadius': '0 0 0 0',
        'anchorActive' : false,
        'anchorName' : '',
        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        }
      },
      elements: [],
      internal_config: {
        showMobile : true,
        'showDesktop' : true,
        height: '800px',
        backgroundColor: '#FFFFFF',
        border: '0 none #000000',
        boxShadow: '0 0 0 0 black initial',
        borderRadius: '0 0 0 0',
        anchorActive : false,
        anchorName : '',
        id: '',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
      }
    }
  }
}
